/**
 * Created by Mark on 18/04/2017.
 */
/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Collapse  , Grid, Row, Col, Clearfix , Table} from 'react-bootstrap';
import ClassService from '../../../services/classes-service.js';
import LanguageSelector from '../../inputs/language-selector.js';
import Toggle from '../../inputs/input.toggle.component.js';
import StaffService from '../../../services/staff-services.js';
import StaffStore from '../../../store/staff-store.js';
import InternationalizationStore from '../../../store/internationalization-store.js';

import Select from  'react-select';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import ReactDOM from 'react';




class ReviewStudents extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = { language:null , selectedStaffJSON:{} , selectedStaff:[] , staff:[] , showLanguages: true , shareTeachers:false};
        this.onLanguageToggle = this.onLanguageToggle.bind(this);
        this.onShareToggle = this.onShareToggle.bind(this);

    }

    setProps(){

        console.log(this.state.selectedStaff);
        this.props.data.sharedTeachers = this.state.selectedStaff;
    }

    componentDidMount() {
        StaffService.getAccountsStaff()
    }

    componentWillMount(){
        StaffStore.on("CHANGE" , () => {
            this.setState({
                staff:StaffStore.allStaff,
            });

            this.handelSelect(StaffStore.allStaff[0] , true)
        });
    }

    onLanguageToggle(){
        this.setState({ showLanguages: !this.state.showLanguages });
    }

    onShareToggle(){
        this.setState({ shareTeachers: !this.state.shareTeachers });
    }

    onLanguageSelect(language){
        this.setState({language:language})
    }

    onStaffSelect(staff){
        this.setState({selectedStaff:staff})
    }

    renderStaffList(){

        return this.state.staff.map(function(staff){

            return <Row className="p-5" >
                        <Col sm={12}>
                            <Toggle isChecked={this.state.shareTeachers} title={staff.getName()} onCheck={this.onShareToggle}/>
                        </Col>
                    </Row>

           // return  { value: staff.getID(), label: staff.getName()}
        }.bind(this));
    }

    handelSelect(staffMember , isSelected){

        let selectedStaff = this.state.selectedStaff;

        if(isSelected)
        {
            selectedStaff.push(staffMember.uid)
        }
        else
        {
            selectedStaff.splice( selectedStaff.indexOf(staffMember.ietf), 1 );
        }

        this.setState({selectedStaff:selectedStaff})

    }

    isSelected(staff){
        return this.state.selectedStaffJSON[staff.uid] != undefined;
    }


    getTableData(){
        return this.state.staff.map(function(staff){

            const classes = staff.classes.map(function(_class){
                return ' ' + _class.name + ' ,';
            });

            return {
                uid:staff.uid,
                name:staff.getName(),
                username:staff.username,
                password:"*******",
                classes:classes
            }
        });
    }

    renderPaginationPanel = (props) => {
        return (
            <div className="row p-t-0 p-l-20 p-r-20">
                <div className="col-sm-6">{ props.components.pageList }</div>
            </div>
        );
    }

    customMultiSelect(props) {
        const { type, checked, disabled, onChange, rowIndex } = props;
        /*
         * If rowIndex is 'Header', means this rendering is for header selection column.
         */
        if (rowIndex === 'Header') {
            return (<span className="bootTable">
                        <div className="checkbox p-l-5">
                            <label>
                        <input type="checkbox"
                           type='checkbox'
                           name={ 'checkbox' + rowIndex }
                           id={ 'checkbox' + rowIndex }
                           checked={ checked }
                           onChange={ onChange } /> <i className="input-helper"></i></label>

                </div></span>);
        } else {


             return     <span className="bootTable">
                            <div className="checkbox p-l-5">
                                <label>
                                    <input type="checkbox"
                                      type="checkbox"
                                      checked={ checked }
                                      disabled={ disabled }
                                      onChange={ e=> onChange(e, rowIndex) }
                                      ref={ input => {
                                                if (input) {
                                                    input.indeterminate = props.indeterminate;
                                                }
                                            }
                                        } />
                            <i className="input-helper"></i></label>
                            </div>
                        </span>;
        }
    }


    handelSelectAll(isSelected, rows){


        let response = [];
        let selected = [];
        for(var idx = 0 ; idx < rows.length; idx++){
            response.push(rows[idx].uid)
        }

        let staffMemebers = [];

        for(var idx = 0 ; idx < StaffStore.allStaff.length; idx++)
        {
            staffMemebers.push(StaffStore.allStaff[idx].uid)
        }


        this.setState({selectedStaff:isSelected ? staffMemebers : []});
        return response;
    }

    render(){

        this.setProps();

        const tableOptions = {
            page: 1,  // which page you want to show as default

            sizePerPage: 10,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages

            paginationShowsTotal: false,
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            hideSizePerPage: true,
            paginationPanel: this.renderPaginationPanel,
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast:true,
            firstPage: '...', // First page button text
            lastPage: '...', // Last page button text
            withoutNoDataText: false,
            noDataText: InternationalizationStore.getTranslation('ui-2011' , '  '),
            // alwaysShowAllBtns: true // Always show next and previous button
            // withFirstAndLast: false > Hide the going to First and Last page button
        };

        if(!this.props.data.sharedTeachers) return null;

        let selected = this.props.data.sharedTeachers.map(function(_staff){
            return _staff
        });

        return (
            <div style={{margin:-10 , paddingBottom:10}}>
                    <BootstrapTable selectRow={{selected:selected , customComponent: this.customMultiSelect , mode:'checkbox' , onSelect:this.handelSelect.bind(this) , onSelectAll: this.handelSelectAll.bind(this) }} csvFileName='table-export.csv' options={tableOptions} data={ this.getTableData() } keyField='uid'  condensed pagination  bordered={ true }>
                        <TableHeaderColumn  width="200" col='0' colSpan='1' dataField='name'   dataSort={ false }><FormattedMessage id={ 'ui-14' } defaultMessage={ 'Name' }/></TableHeaderColumn>
                        <TableHeaderColumn  width="200" col='0' colSpan='1' dataField='username'   dataSort={ false }><FormattedMessage id={ 'ui-22' } defaultMessage={ 'Username' }/></TableHeaderColumn>
                        <TableHeaderColumn  width="100" col='0' colSpan='1' dataField='password'   dataSort={ false }><FormattedMessage id={ 'ui-23' } defaultMessage={ 'Password' }/></TableHeaderColumn>
                        <TableHeaderColumn   col='0' colSpan='1' dataField='classes'   dataSort={ false }><FormattedMessage id={ 'ui-830' } defaultMessage={ 'Username' }/></TableHeaderColumn>
                    </BootstrapTable>
            </div>
        );

    }
}




export default {
    name: <FormattedMessage id={ "ui-866" } defaultMessage={ "Share Class" }/>,
    title:<FormattedMessage id={ "ui-2010" } defaultMessage={ "No Translation" }/>,
    onSubmit: function (done){
        done();
    },
    component: ReviewStudents
}


// WEBPACK FOOTER //
// ./src/components/wizard/create-class-steps/class-settings.js